import gql from 'graphql-tag';

export const createEmailGroup = gql`
  mutation createEmailGroup($input: EmailGroupInput) {
    createEmailGroup(input: $input) {
      id
      name
      enabled
      updater
      createdAt
      updatedAt
      deletedAt
      version
      EmailGroupMembers {
        id
        address
        version
      }
      businessUnits {
        name
        id
      }
    }
  }
`;
